import { EMPTY_LIST } from '../../constants/common'

export const PIE_CHART_COLORS = [
  'var(--color-chart-4)',
  'var(--color-chart-5)',
  'var(--color-chart-1)',
  'var(--color-chart-2)',
  'var(--color-chart-3)',
]

export const CHART_PERCENT_MAX = 100

export const CHART_VALUE_SEPARATOR = ' · '

export const CHART_DEFAULT_NAME_KEY = 'name'

export const CHART_DEFAULT_DATA_KEY = 'value'

export const CHART_RESPONSIVE_CONTAINER_PROPS = {
  height: '100%',
  width: '100%',
}

export const CHART_AXIS_TICK_PROPS = {
  fill: 'var(--secondary-text-color)',
  fontSize: 14,
}

export const PIE_ACTIVE_SECTOR_GROWTH = 3

// Recharts throttles mouse moves to the next frame but hides the tooltip at
// once, so a deferred move after a quick exit brought it back for good.
export const CHART_POINTER_EVENTS_PROPS = { throttledEvents: EMPTY_LIST }
